module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-29.ee1eb9c1.jpg";